import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { BehaviorSubject } from 'rxjs';
import { ValoresBienCulturalResponse } from '../../models/atributos.model';

@Injectable({providedIn: 'root'})
export class AtributosBienCulturalService {

    atributos:BehaviorSubject<ValoresBienCulturalResponse>= new BehaviorSubject<ValoresBienCulturalResponse>(null)
        
    get atributos$(){
        return this.atributos.asObservable()
    }

    constructor(private apiService: ApiService) { }

    getAtributos(){
        const url=`/bien_cultural/catalogo/valores_bienes_culturales` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener las atributos.')
                .subscribe((response: ValoresBienCulturalResponse) => {
                    this.atributos.next(response)
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }
    
}